export default __webpack_public_path__ + "static/media/logo.28e9b193.svg";